import React from "react";

const SidebarItem = ({ children }) => (
  <div className={["sidebar-item"].join(" ")}>{children}</div>
);

export default SidebarItem;
